import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const ChargerStrikethrough = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "m2.134 19.634 17.5-17.5A1.25 1.25 0 0 0 17.866.366L15 3.232V1.25a1.25 1.25 0 1 0-2.5 0v4.482L10.732 7.5H7.5V1.25a1.25 1.25 0 0 0-2.5 0V7.5H3.75c-.69 0-1.25.56-1.25 1.25v5c0 .603.085 1.186.245 1.738L.366 17.866a1.25 1.25 0 0 0 1.768 1.768m3.79-.308A6.2 6.2 0 0 0 8.75 20h2.5a6.25 6.25 0 0 0 6.25-6.25v-5c0-.281-.093-.541-.25-.75z" }) }));
});
ChargerStrikethrough.displayName = 'ChargerStrikethrough';
ChargerStrikethrough.__iconComponentType = 'standard';
export default ChargerStrikethrough;
//# sourceMappingURL=ChargerStrikethrough.js.map